import React, { Component } from 'react';

class Checkbox extends Component {
    handleChange (checked, value) {
        let checkedArray = this.props.checked;
        if (checked) {
            // console.log("adicionando");
            checkedArray.push(value);
        } else {
            // console.log("removendo");
            checkedArray = checkedArray.filter(item => item !== value);
        }
        this.props.onChange(checkedArray);
    }

    sizeControl (event) {
        let checkedArray = this.props.checked;
        if (checkedArray.length < this.props.maxCheck) {
            this.handleChange(event.target.checked, event.target.value);
        } else {
            let finded;
            finded = checkedArray.find((id) => {
                return (event.target.value === id);
            });
            if (finded !== undefined) {
                this.handleChange(event.target.checked, event.target.value);
            }
        }
    }
    renderOptions () {
        let checkedArray = this.props.checked;
        return this.props.options.map((item, index) => {
            let finded;
            // console.log('FINDED', finded);
            finded = checkedArray.find((id) => {
                return (item.id === id);
            });
            return (
                <div key={index} className='ranking-list-item' style={{alignItems: 'center'}}>
                    <input type='checkbox' checked={(finded !== undefined)} value={item._id} id={item._id} onChange={(event) => this.sizeControl(event)} />
                    <label htmlFor={item._id}>{item.title}</label>
                </div>
            );
        });
    }
    render () {
        return (
            <div>
                {this.renderOptions()}
            </div>
        );
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/views/components/checkbox.js